import {
  MetricSummaryCard,
  type MetricSummaryCardProps,
} from '../MetricSummaryCard/MetricSummaryCard';

/** Figma `972:20771`. */
export function NegativeConversationCard(props: MetricSummaryCardProps) {
  return (
    <MetricSummaryCard
      {...props}
      copy={{
        title: 'Negative conversation',
        helpText: 'Shows the number of negative mentions of your brand.',
      }}
    />
  );
}
